import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiLogin, ServerResponse } from '../../api';
import ErrorBox from '../../components/errorBox/ErrorBox';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './Login.css';

interface LoginState {
    serverResponse: ServerResponse | undefined;
    email: string;
    password: string;
    role: string | undefined;
}

export default class LogIn extends React.PureComponent<any, LoginState> {
    constructor(props: any) {
        super(props);
        this.state = {
            email: '',
            password: '',
            role: undefined,
            serverResponse: undefined,
        };
    }

    public render() {
        if (this.state.serverResponse && this.state.serverResponse.OK) {
            if (this.state.role && this.state.role === 'admin') {
                return <Redirect to="/dashboard" />;
            } else {
                return <Redirect to="/cpcourses" />;
            }
        }

        return (
            <>
                <HeaderLoggedOut />
                <Container id="loginView">
                    <Row>
                        <Col md={6} className="mb-4 mb-md-0">
                            <h3>Login</h3>
                            <Form>
                                <ErrorBox serverResponse={this.state.serverResponse} />
                                <FormGroup>
                                    <Label>{TR.logIn_email}</Label>
                                    <Input
                                        type="email"
                                        id="email"
                                        onChange={this.inputHandler}
                                        onKeyDown={this.keyDown}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>{TR.logIn_password}</Label>
                                    <Input
                                        type="password"
                                        id="password"
                                        onChange={this.inputHandler}
                                        onKeyDown={this.keyDown}
                                    />
                                </FormGroup>

                                <Button onClick={this.login}>Login</Button>
                                <Link to="/forgotPassword" className="float-right">
                                    {TR.logIn_forgot_password}
                                </Link>
                            </Form>
                        </Col>
                        <Col md={6}>
                            <h3>{TR.logIn_register}</h3>
                            <p>{TR.logIn_register_help}</p>
                            <Link to="/registration" className="btn">
                                {TR.logIn_register}
                            </Link>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }

    private inputHandler = (e: any) => {
        this.setState({ serverResponse: undefined });
        const newstate = {};
        newstate[e.target.id] = e.target.value;
        this.setState(newstate);
    };

    private keyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            this.login();
        }
    };

    private login = () => {
        ApiLogin({ Username: this.state.email, Password: this.state.password }, (sr) => {
            if (sr.OK) {
                this.setState(
                    {
                        role: sr.Data ? sr.Data.Role : undefined,
                        serverResponse: sr,
                    },
                    () => {
                        if (sr.Data) {
                            localStorage.setItem('userName', sr.Data.Username);
                        }
                    }
                );
            } else {
                this.setState({ role: undefined, serverResponse: sr });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/login/LogIn.tsx